import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { addDays } from 'office-ui-fabric-react/lib/utilities/dateMath/DateMath';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataOperation } from '../../data/DataOperation';
import { Immocom } from '../../specifique/immocom';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import './FicheIdentification.css';

/****************************************************************
 PROPS:
    onPeutChargerLeComposant : bool (==false => on ne charge pas le composant ; ==true => on charge)

    onAffichePanelIdentificationPlanning : bool

    onEnregistrementFiche : méthode
    onFermeFicheIdentificationPlanning : méthode
    onChange : méthode appelée si onAffichageSansPanel = true
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    operation: {},
    periodeOuverture: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    onActiveBoutonEnregistrer: false,

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''


    //, dateEnCoursSauvegardee : null
    //, libelleDateEnCoursSauvegarde : null,
};

export class FicheIdentificationPlanning extends Component {

    _creationContent = () => {

        const { operation, periodeOuverture, isDisabledDateLancementCommercialisation, isDisabledDateLivraison, existeReservationValideeCGCetteAnneeAvantDateLancementCommercialisationPrevue } = this.state;

        const aujourdhui = new Date(Date.now());
        const demain = addDays(aujourdhui, 1);
        const existePeriodeOuverte = periodeOuverture !== null;
        const dateDebutPeriode = existePeriodeOuverte ? new Date(periodeOuverture.annee, new Date(periodeOuverture.dateDebut).getMonth(), 1) : null;

        const infoSurvolDisabledCG = "Cette date n'est pas modifiable si elle est antérieure à une date de clôture CG, ou ultérieure à la date d'aujourd'hui";

        // KP - 1497 (mail) - 01/10/2021 - Date prévisionnelle de commercialisation : empêcher la sélection sur des dates antérieures
        //const minDateLancementCommercialisationPrevue = existeReservationValideeCGCetteAnneeAvantDateLancementCommercialisationPrevue ? new Date(aujourdhui.getFullYear(), 0, 1) : undefined;
        const minDateLancementCommercialisationPrevue = demain;
        const maxDateLancementCommercialisationPrevue = existeReservationValideeCGCetteAnneeAvantDateLancementCommercialisationPrevue ? new Date(aujourdhui.getFullYear(), 11, 31) : undefined;

        return <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6"></div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3">Date prévue</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3">Date réelle</div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">
                        Passage en avant-première
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3">
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDatePassageAvantPremiere">
                        <EUIDatePicker
                            disabled={(!operation.dateLancementCommercialisationPrevue) && (!operation.dateLancementCommercialisation)}
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "operation", "datePassageAvantPremiere", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date réelle"
                            title="Cette date n'est modifiable que si les dates de lancement de commercialisation prévue et réelle sont renseignées"
                            value={operation.datePassageAvantPremiere}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">
                        Commercialisation
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateLancementCommercialisationPrevue">
                        <EUIDatePicker
                            maxDate={maxDateLancementCommercialisationPrevue}
                            minDate={minDateLancementCommercialisationPrevue}
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "operation", "dateLancementCommercialisationPrevue", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date prévue"
                            value={operation.dateLancementCommercialisationPrevue}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateLancementCommercialisation">
                        <EUIDatePicker
                            disabled={isDisabledDateLancementCommercialisation}
                            maxDate={aujourdhui}
                            minDate={existePeriodeOuverte ? dateDebutPeriode : null}
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "operation", "dateLancementCommercialisation", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                            placeholder="Date réelle"
                            title={infoSurvolDisabledCG}
                            value={operation.dateLancementCommercialisation}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">
                        Dépôt pièces notaire
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateDepotPieceNotairePrevue">
                        <EUIDatePicker
                            placeholder="Date prévue"
                            value={operation.dateDepotPieceNotairePrevue}
                            onSelectDate={e => Scriba.state().setObjetPropriete(this, "operation", "dateDepotPieceNotairePrevue", Scriba.date().getChaineISOFromDate(e), this._onValidationSurSortieDeChamp)}
                            minDate={demain}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateDepotPieceNotaire">
                        <EUIDatePicker
                            placeholder="Date réelle"
                            value={operation.dateDepotPieceNotaire}
                            onSelectDate={e => Scriba.state().setObjetPropriete(this, "operation", "dateDepotPieceNotaire", Scriba.date().getChaineISOFromDate(e), this._onValidationSurSortieDeChamp)}
                            maxDate={aujourdhui}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">
                        Livraison
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateLivraisonPrevue">
                        <EUIDatePicker
                            placeholder="Date prévue"
                            value={operation.dateLivraisonPrevue}
                            onSelectDate={e => Scriba.state().setObjetPropriete(this, "operation", "dateLivraisonPrevue", Scriba.date().getChaineISOFromDate(e), this._onValidationSurSortieDeChamp)}
                            minDate={demain}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateLivraison">
                        <EUIDatePicker
                            placeholder="Date réelle"
                            value={operation.dateLivraison}
                            onSelectDate={e => Scriba.state().setObjetPropriete(this, "operation", "dateLivraison", Scriba.date().getChaineISOFromDate(e), this._onValidationSurSortieDeChamp)}
                            title={infoSurvolDisabledCG}
                            disabled={isDisabledDateLivraison}
                            maxDate={aujourdhui}
                        />
                    </div>
                    {/*1592 - minDate enlevé de la date réelle de livraiso */}
                    {/*minDate={existePeriodeOuverte ? dateDebutPeriode : null}*/}
                </div>
            </div>
        </div>;
    };

    constructor(props) {
        super(props);

        this.state = objetState;
    };

    _onInit = () => {
        this.setState(objetState);
    };

    _chargementDonnees = () => {
        if (this.state.operation.idOperation === undefined) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement de l\'opération en cours'
            });

            var chargementFicheIdentificationPlanning = DataOperation._chargementFicheIdentificationPlanning();

            chargementFicheIdentificationPlanning.then(
                responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        const retourData = responseFetch.reponseAPIobjet;
                        let operation = retourData[0];
                        operation.passageAvantPremiere = !!operation.datePassageAvantPremiere;

                        const stateTemp = {
                            operation,
                            periodeOuverture: retourData[1],
                            isDisabledDateLancementCommercialisation: retourData[2],
                            isDisabledDateLivraison: retourData[3],
                            existeReservationValideeCGCetteAnneeAvantDateLancementCommercialisationPrevue: retourData[4],
                            listOperationTVACas: this.props.listTva
                        };
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    };

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du planning de l\'opération en cours'
        });

        let onEnregistrementPlanningIdentification = DataOperation._onEnregistrementPlanningIdentification(this.state.operation, this.state.listOperationTVACas);

        onEnregistrementPlanningIdentification
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this.props.onEnregistrementFiche);
                } else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
    };

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheIdentificationPlanning();
    };

    _onOpen = () => {
        this._chargementDonnees();
    };

    _onRenderFooterContent = () => {
        let boutonActif = this.state.onActiveBoutonEnregistrer;

        return (
            <div>
                <PrimaryButton name="btnEnregistrerPlanning" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!boutonActif}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onMiseAJourChamp(nomObjet, nomPropriete, valeur) {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);
    };

    _onVerificationFormulaire = () => {
        Immocom.fiche()._validationFormulaire(this, 'DatesOperation', this.state.operation, (this.state.operation.idOperation > 0 ? 'Modification' : 'Création'));
    };

    _onValidationSurSortieDeChamp = () => {
        Immocom.fiche()._validationSurSortieDeChamp(this, 'DatesOperation', this.state.operation, (this.state.operation.idOperation > 0 ? 'Modification' : 'Création'));
    };

    render = () => {
        let content = this._creationContent();

        if (this.props.onAffichageSansPanel) {
            return content;
        }
        else {
            return (
                <Panel
                    isOpen={this.props.onAffichePanelIdentificationPlanning}
                    headerText="Modifier le planning de l'opération"
                    type={PanelType.medium}
                    onDismiss={() => this._onAnnulation()}
                    onOpen={() => this._onOpen()}
                    closeButtonAriaLabel="Fermer"
                    onRenderFooterContent={this._onRenderFooterContent}
                >
                    <div className={this.props.classname}>
                        <div className={this.props.classnameinner}>
                            <div className="ms-Grid" dir="ltr">
                                <MessageBars
                                    errorMessage={this.state.errorMessage}
                                    warningMessage={this.state.warningMessage}
                                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                                />

                                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                                {content}
                            </div>
                        </div>
                    </div>
                </Panel>
            );
        }
    };

}